import {createClientError} from '../dam/damClientError';

const uamClientError = createClientError();

export default uamClientError;
